export const getEditorLanguage = (contentType: string, defaultLanguage = 'html') => {
  switch (contentType) {
    case 'application/json':
      return 'json';
    case 'application/xml':
      return 'xml';
    default:
      return defaultLanguage;
  }
};
